import React, { Component } from 'react';

import hlogo from '../imgs/hamilton-logo.png';
import clogo from '../imgs/cincinnati-logo.png';
import vlogo from '../imgs/vieux-logo.svg';

class Footer extends Component {
  toggleModal = () => {
    this.props.modalactivate('disclaimer');
  }

  render() {
    let thisYear = new Date().getFullYear();
    let links;
    if (this.props.links.length > 0) {
      links = this.props.links.map((d) => {
        return (
          <li key={d.url}><a href={d.url} target="_blank" rel="noopener noreferrer" className="underline f5">{d.title}</a></li>
        );
      });
    }
    return (
      <footer className="bg-accent pv3 msdgc-footer">
        <div className="mw8 center cf ph2">
          <nav className="fl w-third dn db-ns">
            <ul className="list pl0 ma0 accent-comp lh-copy">
              {links}
            </ul>
          </nav>
          <div className="fl w-100 w-two-thirds-ns">
            <ul className="list ma0 pl0 tc tr-ns">
              <li className="dib w-40 w-10-ns v-mid"><img className="w-auto h-auto" src={hlogo} alt="Hamilton County Ohio Logo" /></li>
              <li className="dib w-75 w-third-ns v-mid mh4-ns"><img className="w-auto h-auto" src={clogo} alt="City of Cincinnati Logo" /></li>
              <li className="dib w-50 w-20-ns v-mid"><img width="175" className="h-auto" src={vlogo} alt="Vieux & Associates Logo" /></li>
            </ul>
            <p className="tc tr-ns accent-comp"><button className="input-reset bg-transparent reset underline pointer accent-comp" onClick={this.toggleModal}>Data Disclaimer</button> - © {thisYear}, <a href="http://www.vieuxinc.com">Vieux & Associates, Inc.</a></p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js